import { combineReducers } from "redux";
import themeUsersReducer from "./themeUsers/reducers";
import { readMessageReducer } from "./message/reducers";
import { readNotificationReducer } from "./notification/reducers";
import authReducer from "./authentication/reducers";
import ChangeLayoutMode from "./themeLayout/reducers";
import { teamReducer } from "./team/reducers";
import { usersReducer } from "./users/reducers";
import { POSMadaReducer } from "./posMadaOps/reducers";
import { sellersReducer } from "./sellers/reducers";
import { headerSearchReducer } from "./headerSearch/reducers";
import orderReducer from "./orders/reducers";
import galleryReducer from "./gallary/reducers";
import { emailReducer, SingleEmailReducer } from "./email/reducers";
import { productReducer, SingleProductReducer } from "./product/reducers";
import {
  chatReducer,
  SingleChatReducer,
  groupChatReducer,
  SingleChatGroupReducer,
} from "./chat/reducers";
import { projectReducer, SingleProjectReducer } from "./project/reducers";
import {
  axiosCrudReducer,
  axiosSingleCrudReducer,
} from "./crud/axios/reducers";
import cartData from "./cart/reducers";
import Todo from "./todo/reducers";
import Note from "./note/reducers";
import Task from "./task/reducers";
import kanbanBoardReducer from "./kanban/reducers";
import Contact from "./contact/reducers";
import Profile from "./profile/reducers";
import Calender from "./calendar/reducers";
import FileManager from "./fileManager/reducers";
import tickets from "./supportTickets/reducers";
import jobs from "./jobs/reducers";
import dataTable from "./data-filter/reducers";
import { brandReducer } from "./brands/reducers";
import { stockReducer } from "./stock/reducers";
import { merchantGroupReducer } from "./merchantGroups/reducers";
import { salesReducer } from "./sales/reducers";
import { regionsReducer } from "./regions/reducers";
import { walletsReducer } from "./wallet/reducers";
import { membersReducer } from "./members/reducers";
import { branchesReducer } from "./branches/reducers";
import { activitiesReducer } from "./activities/reducers";
import { employeesReducer } from "./employees/reducers";
import { subscriptionsReducer } from "./subscriptions/reducers";
import { subscriptionPackagesReducer } from "./subscriptionPackages/reducers";
import { countriesReducer } from "./countries/reducers";
import { attendancesReducer } from "./attendance/reducers";
import { qrcodesReducer } from "./qrcodes/reducers";
import { paymentsReducer } from "./payments/reducers";
import { statisticsReducer } from "./statistics/reducers";

const rootReducers = combineReducers({
  themeUsers: themeUsersReducer,
  headerSearchData: headerSearchReducer,

  members: membersReducer,
  branches: branchesReducer,
  activities: activitiesReducer,
  employees: employeesReducer,
  subscriptions: subscriptionsReducer,
  subscriptionPackages: subscriptionPackagesReducer,
  countries: countriesReducer,
  attendances: attendancesReducer,
  qrcodes: qrcodesReducer,
  payments: paymentsReducer,
  statistics: statisticsReducer,

  message: readMessageReducer,
  notification: readNotificationReducer,
  orders: orderReducer,
  sellers: sellersReducer,
  users: usersReducer,
  brands: brandReducer,
  regions: regionsReducer,
  wallet: walletsReducer,
  posMadaOperations: POSMadaReducer,
  sales: salesReducer,
  team: teamReducer,
  auth: authReducer,
  gallery: galleryReducer,
  email: emailReducer,
  emailSingle: SingleEmailReducer,
  products: productReducer,
  merchantGroups: merchantGroupReducer,
  product: SingleProductReducer,
  chatSingle: SingleChatReducer,
  chatSingleGroup: SingleChatGroupReducer,
  chat: chatReducer,
  groupChat: groupChatReducer,
  projects: projectReducer,
  project: SingleProjectReducer,
  ChangeLayoutMode,
  cart: cartData,
  Todo,
  Note,
  AxiosCrud: axiosCrudReducer,
  Task,
  KanbanBoard: kanbanBoardReducer,
  Contact,
  Profile,
  Calender,
  FileManager,
  tickets,
  jobs,
  dataTable,
  SingleAxiosCrud: axiosSingleCrudReducer,
  stock: stockReducer,
});

export default rootReducers;
